type CheckoutButtonStateType = {
  buttonLabel: string;
  isCheckoutEnabled: boolean;
};

const getAriaLabel = (
  name: string,
  description: string,
  from: boolean,
  currencySymbol: string,
  translate: any,
): string =>
  `${name}, ${description} ${from && translate('From')} ${currencySymbol}`;

const getButtonState = (
  acceptPreOrders: boolean,
  isDeliveryOrder: boolean,
  isOutsideDeliveryZone: boolean,
  isOpen: boolean,
  translate: any,
): CheckoutButtonStateType => {
  if (isDeliveryOrder && isOutsideDeliveryZone) {
    return {
      buttonLabel: translate('Cannot_deliver_checkout'),
      isCheckoutEnabled: false,
    };
  }

  if (isOpen) {
    return {
      buttonLabel: translate('Checkout'),
      isCheckoutEnabled: true,
    };
  }

  if (acceptPreOrders) {
    return {
      buttonLabel: translate('Preorder'),
      isCheckoutEnabled: true,
    };
  }

  return {
    buttonLabel: translate('Closed'),
    isCheckoutEnabled: false,
  };
};

const getCategoryTranslationKey = (category: number): string => {
  switch (category) {
    case 0:
      return 'Restaurant_lowercase';
    case 1:
      return 'Cafe_lowercase';
    case 2:
      return 'Store_lowercase';
    default:
      return 'Restaurant_lowercase';
  }
};

export const restaurantMenuUtils = {
  getAriaLabel,
  getButtonState,
  getCategoryTranslationKey,
};
